import classNames from "classnames";
import styles from "./PictureOrVideo.module.css";
import { getAssetPath, getAssetPathAndSize, getAssetPathByHeight } from "utils";
import { getSrcSet } from "utils/getAssetSrcSet";
import { useDeviceClassification } from "utils";
import he from "he";


export interface PictureOrVideoProps {
  isHero?: boolean,
  className?: string;
  alt: string;
  src: string;
  autoPlay?: boolean;
  loop?: boolean;
  backgroundItem?: any;
  specifySize?: { width: number, x?: number }
}

export const PictureOrVideo = ({
  specifySize,
  backgroundItem,
  isHero,
  src,
  alt,
  autoPlay = false,
  loop = false,
  className = "",
  ...props
}: PictureOrVideoProps) => {

  const isVideo = !backgroundItem && src?.split(".").pop() === "mp4" ? true : false;
  const { isMobile } = useDeviceClassification();

  return (
    <div style={{ overflow: 'hidden', width: '100%' }}>
      <div className={classNames(styles.pictureorvideo, className)} {...props}>
        {!backgroundItem && isVideo && (
          <video playsInline muted autoPlay={autoPlay} loop={loop} title={alt}>
            <source src={getAssetPath(src)} type="video/mp4" />
          </video>
        )}

        {!backgroundItem && !isVideo && (
          <>
            {isHero && <img
              style={{ width: '100%', height: '100vh', transform: isMobile ? 'scale(1)' : 'scale(1.02)' }}
              src={getAssetPathByHeight(src, window.innerHeight)}
              alt={alt}
            />}
            {!isHero && <img
              style={{ width: '100%', height: isHero ? '100vh' : '100%', transform: isMobile ? 'scale(1)' : 'scale(1.02)' }}
              src={specifySize ? getAssetPathAndSize(src, specifySize.width, specifySize.x) : getAssetPath(src)}
              srcSet={specifySize ? null : getSrcSet(getAssetPath(src), [150, 300, 480, 768, 1024, 2048])}
              alt={alt}
            />}
          </>

        )}

        {backgroundItem && <div style={{ background: `${backgroundItem.Background}` }} className={styles.mainPanel}>
          <div className="textWrapper">
            <span>{he.decode(backgroundItem.Title)}</span>
            <h1>{he.decode(backgroundItem.Description)}</h1>
          </div>
        </div>}

      </div>
    </div>
  );
};
